export const EXPIRY_HOUR = new Date(new Date().getTime() + 60 * 60 * 1000); // an hour, can also do 2/48
export const EXPIRY_14_DAYS = new Date(new Date().getTime() + 14 * 24 * 60 * 60 * 1000);
